import {Component, EventEmitter, Input, Output} from '@angular/core';
import {FieldDataDto, TaskDto} from '../../../../../Models/Tasks/General/task.interface';

@Component({
  selector: 'app-core-field',
  templateUrl: './core-field.component.html',
  styleUrls: ['./core-field.component.scss'],
  standalone: false
})
export class CoreFieldComponent {
  @Input() task?: TaskDto;
  @Input() field!: FieldDataDto;

  @Input() menu: string = '';

  @Output() openImage: EventEmitter<void> = new EventEmitter<void>();
  @Output() takeImage: EventEmitter<void> = new EventEmitter<void>();
}
